<template>
  <modal
    :show.sync="isActiveLocal"
    centered
    header-classes="bg-primary items-center rounded-none text-lg uppercase font-bold"
    modal-content-classes="cust-medi-popup cust-overflow-y-grey"
    hide-footer
    class="overflow-y-hidden"
  >
    <div class="flex justify-between pb-8">
      <div class="my-auto">
        <div class="font-medium text-2xl text-black text-center">
          <span class="bold">Rejected</span>

          <p class="mt-2">
            A confirmation email has been sent to the volunteer's Email ID
          </p>
        </div>
      </div>
      <img
        src="@/assets/images/cross.png"
        class="h-8 w-8 cursor-pointer"
        alt="cross"
        @click="isActiveLocal = false"
      />
    </div>

    <div class="" v-html="RejectAppplicationreq.reason"></div>
    <template slot="footer" class="hidden"> <div></div> </template>
  </modal>
</template>

<script>
export default {
  props: {
    isActiveReject: {
      type: Boolean,
      default: false,
    },

    RejectAppplicationreq: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    isActiveLocal: {
      get() {
        return this.isActiveReject;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>
